/*
 * These are copied from the uswds source.
 * https://github.com/uswds/uswds/blob/v2.8.1/src/js/components/file-input.js
 */

export const DROPZONE_CLASS = 'usa-file-input';
export const INPUT_CLASS = 'usa-file-input__input';
export const TARGET_CLASS = 'usa-file-input__target';
export const BOX_CLASS = 'usa-file-input__box';
export const INSTRUCTIONS_CLASS = 'usa-file-input__instructions';
export const PREVIEW_CLASS = 'usa-file-input__preview';
export const PREVIEW_HEADING_CLASS = 'usa-file-input__preview-heading';
export const DISABLED_CLASS = 'usa-file-input--disabled';
export const CHOOSE_CLASS = 'usa-file-input__choose';
export const ACCEPTED_FILE_MESSAGE_CLASS = 'usa-file-input__accepted-files-message';
export const DRAG_TEXT_CLASS = 'usa-file-input__drag-text';
export const DRAG_CLASS = 'usa-file-input--drag';
export const LOADING_CLASS = 'is-loading';
export const HIDDEN_CLASS = 'display-none';
export const INVALID_FILE_CLASS = 'has-invalid-file';
export const GENERIC_PREVIEW_CLASS_NAME = 'usa-file-input__preview-image';
export const GENERIC_PREVIEW_CLASS = `${GENERIC_PREVIEW_CLASS_NAME}--generic`;
export const PDF_PREVIEW_CLASS = `${GENERIC_PREVIEW_CLASS_NAME}--pdf`;
export const WORD_PREVIEW_CLASS = `${GENERIC_PREVIEW_CLASS_NAME}--word`;
export const VIDEO_PREVIEW_CLASS = `${GENERIC_PREVIEW_CLASS_NAME}--video`;
export const EXCEL_PREVIEW_CLASS = `${GENERIC_PREVIEW_CLASS_NAME}--excel`;
export const SPACER_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
